import { DataSource } from '@angular/cdk/table';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { MedicalLetterEmployeeDatabase } from './medical-letter-employee-database';
import { MedicalLetterDto } from '../../../../models/medical-letter/medical-letter-dto';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


export class MedicalLetterEmployeeDataSource extends DataSource<any> {
    _medicalLetterType = -1;
    _filterChange = new BehaviorSubject('');

    filteredData: MedicalLetterDto[] = [];
    renderedData: MedicalLetterDto[] = [];
    dataLength = 0;

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    filterMedicalLetterByType(_medicalLetterType) {
        this._medicalLetterType = _medicalLetterType;
        this._filterChange.next(this.filter);
    }

    constructor(
        private _employeeDatabase: MedicalLetterEmployeeDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort,
        private _medicalLetterTypeSelected
    ) {
        super();
        this._medicalLetterType = _medicalLetterTypeSelected;

        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<MedicalLetterDto[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._employeeDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._employeeDatabase.data.slice().filter((item: MedicalLetterDto) => {
                return (this._medicalLetterType === -1 || item.MedicalLetterTypes.find(t => t === this._medicalLetterType));
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._employeeDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: MedicalLetterDto[]): MedicalLetterDto[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }
        return data.sort((a, b) => {
            const propertyA: number | string = '';
            const propertyB: number | string = '';
            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/medical-letter/medical-letter-employee-data-source.ts